/**
 * Specify the context of the AI prompt
 */
export enum AI_PROMPT_CONTEXT_TYPES {
  ALL_PREVIOUS_ACTION_STEPS = 'all previous action steps',
  SPECIFIC_ACTION_STEP_OUTPUTS = 'specific action step outputs',
}
